import React from 'react';
import { shape } from 'prop-types';
import { Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { AppWrappperHOC } from '../../Root/HOC';
import LandingContainer from '../../../components/LandingContainer';
import Journey from '../../../containers/NewLanding/Journey';
import endPoints from '../../../config/endPoints';
import { constants } from '../../../devUtils';
import News from '../../Press/news';
import { NEWS_ARTICLES } from '../../Press/constants';
import { HelmetWrapper } from '../../../components';

const StyledNews = styled.section`
  .image-grayscale{
    filter: grayscale(100%);
  }
  h1{
    font-family: 'Mulish',sans-serif;
    color: ${({ theme }) => theme.LandingBlack};
  }
  p{
    color: ${({ theme }) => theme.LandingBlack};
  }
`;

function Press(props) {
  const data = NEWS_ARTICLES;
  const { location } = props;
  return (
    <StyledNews>
      <HelmetWrapper location={location} />
      <div className="gray-greadient">
        <section className="padding-tb-5">
          <LandingContainer>
            <Row align="top" type="flex" justify="start" gutter={32}>
              <Col xs={24} sm={24} md={24} lg={11} xl={11} className="padding-t-3">
                <p>Company</p>
                <h1>Zaggle Newsroom</h1>
                <p className="padding-r-2">Get an update on current fin-tech marketing trends and various evolving technologies in the market.
                </p>
                <Link to={constants.LINK_CONTACTUS} className="btn red-btn margin-t-1">Reach Us Now</Link>
              </Col>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <img
                  src={endPoints.NEWS_LANDING_IMAGE.URL}
                  alt={endPoints.NEWS_LANDING_IMAGE.ALT}
                  className="width-100 image-grayscale"
                />
              </Col>
            </Row>
            {data.map((item) => (
              <News
                key={item.key}
                {...item}
              />
            ))}
          </LandingContainer>
        </section>
        <Journey />
      </div>
    </StyledNews>
  );
}

Press.propTypes = {
  location: shape({}).isRequired,
};

const component = AppWrappperHOC(Press);

export { Press };
export default component;



// WEBPACK FOOTER //
// client/containers/StaticPages/Press/index.js